var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKeylock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2505 1.5C14.7922 1.5 16.5 3.2835 16.5 5.937V12.063C16.5 14.7165 14.7922 16.5 12.249 16.5H5.748C3.207 16.5 1.5 14.7165 1.5 12.063V5.937C1.5 3.2835 3.207 1.5 5.748 1.5H12.2505ZM12.2505 2.625H5.748C3.85125 2.625 2.625 3.92475 2.625 5.937V12.063C2.625 14.0752 3.85125 15.375 5.748 15.375H12.249C14.148 15.375 15.375 14.0752 15.375 12.063V5.937C15.375 3.92475 14.148 2.625 12.2505 2.625ZM6.6276 7.0488C7.50907 7.04941 8.25408 7.635 8.49621 8.43669L12.7573 8.43713C13.0678 8.43713 13.3198 8.68913 13.3198 8.99963V10.3894C13.3198 10.6999 13.0678 10.9519 12.7573 10.9519C12.4468 10.9519 12.1948 10.6999 12.1948 10.3894V9.56213L11.1982 9.56175L11.1986 10.3894C11.1986 10.6999 10.9466 10.9519 10.6361 10.9519C10.3256 10.9519 10.0736 10.6999 10.0736 10.3894L10.0732 9.56175L8.49654 9.56247C8.25456 10.3651 7.50839 10.9518 6.6276 10.9518C5.55135 10.9518 4.6761 10.0758 4.6761 9.0003C4.6761 7.92405 5.55135 7.0488 6.6276 7.0488ZM6.6291 8.1738C6.1716 8.1738 5.8011 8.5443 5.8011 9.0003C5.8011 9.4563 6.1716 9.8268 6.6276 9.8268C7.08285 9.8268 7.4541 9.4563 7.4541 9.0003C7.4541 8.54505 7.0836 8.17455 6.6291 8.1738Z",
    fill: "#666666"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeylock);
export default __webpack_public_path__ + "static/media/keylock.64ed4fba.svg";
export { ForwardRef as ReactComponent };